import { render, staticRenderFns } from "./BaseMessageForm.vue?vue&type=template&id=285ee9d6"
import script from "./BaseMessageForm.vue?vue&type=script&lang=js"
export * from "./BaseMessageForm.vue?vue&type=script&lang=js"
import style0 from "./BaseMessageForm.vue?vue&type=style&index=0&id=285ee9d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports